import {NiTree, NiInput, NiButton, NiNoData, NiLine} from "@/ni-ui"
import tree_op from "../common/mixin/tree_op"
import * as API from "@/api/index.js"
import {getTableHeight} from "@/common"

export default {
  mixins: [tree_op],
  components: {
    NiTree,
    NiInput,
    NiButton,
    NiNoData,
    NiLine,
  },

  props: {
    canClose: {
      type: Boolean,
      default: false,
    },
    show_header: {
      type: Boolean,
      default: false,
    },

    tree_style: {
      type: Object,
      default: function () {
        return {}
      }
    },

    //内容高度
    content_height: {
      type: String,
      default() {
        return ""
      }
    },
    //是否自动选中第一个
    auto_select_first: {
      type: Boolean,
      default: true
    },

    only_parent: {
      type: String,
      default: "",    //1：只展示第一级节点数据
    },

    target_value: {

    },
    deeper:{
        default:false,
      },

    value_field: {
      type: String,
      default: "id"
    },   // target_value 的取值字段


    model_type: {
        type: String,
        default: "0",    // 0 为字符串，1 为数组
    },

    node_all_expand: {
      type: Boolean,
      default: true,
    },

    req_param: {
      type: Object,
      default: function () {
        return {"service":"dish.dish_type_query"}
      }
    },

    data_checked: {
      type: Array,
      default: function () {
        return []
      }
    },

    no_border: {
      type: Boolean,
      default: false,
    }

  },
  computed: {
    open_cust_icon() {
      if (this.open_cust) {
        return "#cms_right"
      } else {
        return "#cms_left"
      }
    }
  },
  data() {
    return {

      open_cust: false,
      button_style: {
        "transform": "translateY(-6px)",
        "padding-left": "0px",
        "padding-right": "0px",
        "padding-top": "10px",
        "padding-bottom": "10px",
        "background": "#efefef",

      },
      icon_style: {
        "width": "1rem",
        "height": "1rem",
      },
      search_tree_form: {
        search_content: "",
      },

      content_style: {
        height: this.content_height
      },

      tree_ref: "tree_ref",

      tree_loading: false,
      tree_nodes: [],
      tree_setting: {
        data: {
          key: {
            title: "orginal",
            name: "text",
            id: "id",
          },

        },
        view: {
          showIcon: true,
          nameIsHTML: true,
          fontCss: {"font-size": "12px", "font-family": "微软雅黑bai"}
        },
        check: {
          enable: this.model_type == "1",
          autoCheckTrigger: true,
          chkboxType: { "Y": "", "N": "" },
        },
        callback: {
          onClick: this.nodeClick,
          onCheck: this.nodeCheck,
        }
      },
      current_node: null,

      tree_data_dict: {},

      target_node: null,

      multiple_selections: [],


    }
  },

  mounted() {
    this.getData()
  },

  watch: {
    data_checked:{
      handler: function (data) {
        this.$_set_node_checked(this.tree_ref, data, this.value_field);
        this.$emit("node_checked", JSON.parse(JSON.stringify(data)));
      },
      deep: true,
      immediate: true,
    },

      req_param:{
        handler: function (data) {
          this.search_data()
        },
        deep: true
      },
  },

  methods: {

    cancel_select(){
      let treeObj = this.get_tree_obj(this.tree_ref)
      if(!treeObj){
        return null;
      }

      treeObj.cancelSelectedNode(this.current_node);
    },

    get_parent_node(val){
      let treeObj = this.get_tree_obj(this.tree_ref)
      if(!treeObj){
        return null;
      }
      return treeObj.getNodeByParam(this.value_field, val);
    },

    upd_node(row){
      let treeObj = this.get_tree_obj(this.tree_ref)
      if(!treeObj){
        return null
      }
      row.text = row.name;
      row.orginal = row.name;
      let target_node = treeObj.getNodeByParam(this.value_field, row[this.value_field])
      let index = treeObj.getNodeIndex(target_node);
      let parent_node = treeObj.getNodeByParam(this.value_field, row.pid);
      treeObj.removeNode(target_node);
      return treeObj.addNodes(parent_node, index, row);
    },

    add_node(row){
      let treeObj = this.get_tree_obj(this.tree_ref)
      if(!treeObj){
        return null
      }

      row.text = row.name;
      row.orginal = row.name;
      let parent_node = treeObj.getNodeByParam(this.value_field, row.pid);
      treeObj.addNodes(parent_node, row);
    },

    move_node(row){
      let treeObj = this.get_tree_obj(this.tree_ref)
      if(!treeObj){
        return null
      }
      let node = treeObj.getNodeByParam(this.value_field, row[this.value_field])
      treeObj.removeNode(node)
    },

    select_target_node(value) {
      let treeObj = this.get_tree_obj(this.tree_ref)
      if(!treeObj){
        return null
      }

      this.target_node = null
      let is_single = this.model_type == '0'
      this.target_node = treeObj.getNodesByFilter(node => this.node_filter(node, value), is_single)
      // this.get_target_node(this.tree_nodes, value)
      if(is_single){
        treeObj.selectNode(this.target_node);
        this.nodeClick(null, this.target_node.tId, this.target_node)
      }else {
        treeObj.checkAllNodes(false);
        this.target_node.map(node =>{
          treeObj.checkNode(node, true, false, true)
        })

      }
      return this.target_node

    },

    node_filter(node, value){
      return this.model_type == '1' ? value.indexOf(node[this.value_field]) > -1 : value === node[this.value_field];
    },

    get_target_node(nodes, value) {
      for (var i = 0; i < nodes.length; i++) {
        let node = nodes[i]
        if (this.model_type === '0' && value == node[this.value_field]) {
          this.target_node = node
          break;
        }
        if (this.model_type === '1' && value.indexOf(node[this.value_field]) > -1){
          if (this.target_node === null){
            this.target_node = [node]
          } else {
            this.target_node.push(node)
          }
        }

        if (node.children && node.children.length > 0) {
          this.get_target_node(node.children, value)
        }
      }
    },


    init_nodes(nodes, is_search) {
      nodes.map(node => {

        if (!is_search && this.target_value && this.target_value == node[this.value_field]) {
          this.$emit("node_click", node)
        }

        if (this.model_type === '1' && this.data_checked.length > 0){
          let is_exist = this.data_checked.some(item => item[this.value_field] === node[this.value_field])
          if (is_exist){
            node.checked = true;
          }
        }

        if (node.children && node.children.length > 0) {
          node.open = this.node_all_expand;
          this.init_nodes(node.children, is_search)
        }

      })
console.log(nodes)
      return nodes

    },

    nodeClick(event, treeId, treeNode) {
      this.current_node = treeNode;
      this.$emit("node_click", treeNode);

    },

    nodeCheck(event, treeId, treeNode){
      let treeObj = this.get_tree_obj(this.tree_ref)
      this.multiple_selections = treeObj.getCheckedNodes(true)
      this.$emit("node_checked", this.multiple_selections)
    },

    search_data() {
      this.getData(true)
    },

    async getData(is_search) {
      var search_data = this.req_param

      this.tree_loading = true
      const response = await API.POST('/omnis/template_data/data', search_data)
      this.tree_loading = false
      if (response && response.data) {
          var data = response.data
          if (data.success) {
            this.tree_nodes = this.init_nodes(data.data, is_search)
          }
      }

    },

    tree_to_dict(nodes) {
      nodes.map(node => {
        this.tree_data_dict[node.id] = node
        if (node.children && node.children.length > 0) {
          this.tree_to_dict(node.children)
        }
      })
    },
  },


}



// WEBPACK FOOTER //
// ./src/omnis-business/host-panel-tree/tree.js